// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"f45fe7d0","453":"19e946da","719":"f07da522"}[chunkId] + ".chunk.js";
};